// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"UQ-z","categoryName":"VQ-z","categoryNameSearchHeader":"WQ-z","categoryContent":"XQ-z","bottomAligned":"YQ-z","image":"ZQ-z","imageNoBackground":"_Q-z"};